// Experimental foreground-only heuristic, not an OS pedometer or transport classifier.
export class StepEstimator {
  constructor(initialSteps = 0) { this.steps = initialSteps; this.samples = 0; this.flags = new Set(); this.resetSegment(); }
  resetSegment() { this.baseline = null; this.lastTime = null; this.warmStart = null; this.segmentSamples = 0; this.armed = true; this.lastPeak = null; this.streak = 0; this.cadence = 0; }
  sample({ x, y, z, timestamp }) {
    if (![x,y,z,timestamp].every(v => typeof v === 'number' && Number.isFinite(v))) return this.result(false);
    if (this.lastTime !== null && timestamp <= this.lastTime) return this.result(false);
    if (this.lastTime !== null && timestamp-this.lastTime > 1500) { this.resetSegment(); this.flags.add('sensor_gap'); }
    this.lastTime = timestamp; this.samples++; this.segmentSamples++;
    const magnitude = Math.hypot(x,y,z);
    if (this.baseline === null) { this.baseline=magnitude; this.warmStart=timestamp; return this.result(true); }
    const signal = magnitude-this.baseline;
    this.baseline += 0.08*(magnitude-this.baseline);
    if (timestamp-this.warmStart < 1000 || this.segmentSamples < 20) return this.result(true);
    if (Math.abs(signal)>18) { this.flags.add('strong_vibration'); this.streak=0; this.armed=false; return this.result(true); }
    if (signal<0.35) this.armed=true;
    if (signal>1.15 && this.armed) {
      this.armed=false;
      const interval=this.lastPeak===null ? null : timestamp-this.lastPeak;
      this.lastPeak=timestamp;
      if(interval!==null && interval<350) { this.flags.add('implausible_cadence'); this.streak=0; return this.result(true); }
      if(interval===null || interval>1600) { this.streak=1; this.cadence=0; }
      else { this.streak++; this.cadence=Math.round(60000/interval); if(this.streak===3)this.steps+=3; else if(this.streak>3)this.steps++; }
    }
    return this.result(true);
  }
  result(valid) { return {steps:this.steps,samples:this.samples,cadence:this.cadence,flags:[...this.flags],warming:this.segmentSamples<20||this.warmStart===null||this.lastTime-this.warmStart<1000,valid}; }
}
export function vectorFromMotion(event) {
  for(const a of [event.acceleration,event.accelerationIncludingGravity]) {
    if(a && [a.x,a.y,a.z].every(v=>typeof v==='number'&&Number.isFinite(v))) return {x:a.x,y:a.y,z:a.z};
  }
  return null;
}
export const motionWarning = flag => ({strong_vibration:'Strong vibration detected. Shaking or transport can resemble steps.',implausible_cadence:'Unusual cadence detected. This may not be walking.',sensor_gap:'Sensor coverage was interrupted. Missing steps were not invented.',no_samples:'Motion readings stopped or never arrived.'}[flag] || 'Movement could not be verified');
